
/**
 * Custom component for Bimini default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.0.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2023-06-07 (1.0.0) (jhoward)
 *    - Copy from Bimini_defaultSection.vue component to PanchoWillies_defaultSection.vue component.
 *
 *  2023-06-21 (1.0.1) (jhoward)
 *    - Give PanchoWillies_defaultSection.vue a default background color.
 *
 *  2023-07-26 (1.0.2) (jhoward)
 *    - Fix over-generic CSS selectors in PanchoWillies_defaultSection.vue.
 *
 *  2023-08-23 (1.1.0) (jhoward)
 *    - Use <menu-version> in <PanchoWillies_defaultSection>.
 *
 *  2024-07-19 (1.1.1) (jhoward)
 *    - Rename .visual_menu--tag CSS rules to .menu--tag in <pancho-willies-default-section>.
 *
 *  2025-02-10 (1.2.0) (jhoward)
 *    - Add <menu-schedules> to the <pancho-willies-default-section> component if in admin view.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <default-textual-section> and <default-visual-section> in <PanchoWillies_defaultSection>.
 *    - Add textual and visual menu CSS tweaks to <PanchoWillies_defaultSection>.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MENU_ITEM_TAG_LOCATIONS, MenuSection} from "../defs";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";

export default defineComponent({
  components: {
    DefaultTextualSection, DefaultVisualSection,
  },
  name: "PanchoWillies_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
})
